import * as yup from 'yup';
import * as geojsonValidation from 'geojson-validation';

export const addValidationSchema = yup.object().shape({
  certifyingBodyPartyId: yup
    .string()
    .required('Certifying Body Party is required'),
  certificateHolderPartyId: yup
    .string()
    .required('Certificate Holder Party is required'),
  certificateType: yup
    .string()
    .required('Certificate Type is required'),
  status: yup
    .string()
    .required('Status is required'),
  certificateName: yup
    .string()
    .required('Certificate Name is required')
    .matches(/(\S.*)/, 'Certificate Name should not be blank'),
    gisBoundary: yup.string().nullable(true)
        .test('is-geometry', 'Invalid GeoJSON geometry object', (value) => {
            try {
                JSON.parse(value);
                return value === null || geojsonValidation.isGeometryObject(JSON.parse(value));
            } catch (error) {
                return false;
            }
        }),
    data: yup.string().nullable(true).test("json", "Invalid JSON format", (value) => {
        try {
            JSON.parse(value);
            return true;
        } catch (error) {
            return false;
        }
    }),
});

export const editValidationSchema = yup.object().shape({
  certificateType: yup
    .string()
    .required('Certificate Type is required'),
  status: yup
    .string()
    .required('Status is required'),
  certificateName: yup
    .string()
    .required('Certificate Name is required')
    .matches(/(\S.*)/, 'Certificate Name should not be blank'),
    gisBoundary: yup.string().nullable(true)
        .test('is-geometry', 'Invalid GeoJSON geometry object', (value) => {
            try {
                JSON.parse(value);
                return value === null || geojsonValidation.isGeometryObject(JSON.parse(value));
            } catch (error) {
                return false;
            }
        }),
    data: yup.string().nullable(true).test("json", "Invalid JSON format", (value) => {
        try {
            JSON.parse(value);
            return true;
        } catch (error) {
            return false;
        }
    }),
});

export const masterCertificateTypes = [
  {
    key: 0,
    value: 'EO100',
    text: 'EO100'
  },{
    key: 1,
    value: 'INTERTEK_CARBONZERO',
    text: 'INTERTEK_CARBONZERO'
  },{
    key: 2,
    value: 'INTERTEK_CARBONCLEAR',
    text: 'INTERTEK_CARBONCLEAR'
  },
{
    key: 3,
    value: 'EU_IMPORT',
    text: 'EU_IMPORT'
}
];


export const masterCertificateStatus = [
  {
    key: 0,
    value: 'ACTIVE',
    text: 'ACTIVE'
  },{
    key: 1,
    value: 'INACTIVE',
    text: 'INACTIVE'
  },{
    key: 2,
    value: 'PENDING',
    text: 'PENDING'
  }
];